export default {
  BT_HDP: "让球",
  BT_OU: "大/小",
  BT_ML: "独赢",
  BT_1X2: "1X2",
  BT_1X2HDP: "三项让分投注",
  BT_CS: "波胆",
  BT_OE: "单/双",
  BT_DC: "双重机会",
  BT_HTFT: "半场/全场",
  BT_FGLG: "最先进球/最后进球",
  BT_TG: "总进球",
  BT_OR: "优胜冠军",
  BT_ORZ: "优胜冠军",

  BT_ANB: "客场无效",
  BT_BS: "双方/一方/两者皆不得分",
  BT_CL: "零失球",
  BT_DNB: "平手无效",
  BT_HNB: "主场无效",
  BT_TWTN: "零失球的胜方",

  BT_HDPF: "全场让球",
  BT_OUF: "全场大",
  BT_MLF: "全场独赢",
  BT_1X2F: "全场1X2",
  BT_1X2HDPF: "全场三项让分投注",
  BT_CSF: "全场波胆",
  BT_OEF: "全场单",
  BT_DCF: "全场双重机会",
  BT_FGLGF: "全场最先进球/最后进球",
  BT_TGF: "全场总进球",

  BT_HDPH: "上半场让球",
  BT_OUH: "上半场大/小",
  BT_MLH: "上半场独赢",
  BT_1X2H: "上半场1X2",
  BT_1X2HDPH: "上半场三项让分投注",
  BT_CSH: "上半场波胆",
  BT_OEH: "上半场单/双",
  BT_DCH: "上半场双重机会",
  BT_FGLGH: "上半场最先进球/最后进球",
  BT_TGH: "上半场总进球",

  BT_HDPOU: "让球&大小",
  BT_PARLAY: "混合过关",
  BT_FT: "全场",
  BT_1H: "上半场",
  BT_2H: "下半场",

  BT_FG: "最先进球",
  BT_LG: "最后进球",
  BT_HFG: "主先",
  BT_AFG: "客先",
  BT_HLG: "主后",
  BT_ALG: "客后",
  BT_NG: "无进球",
  BT_HY: "主是",
  BT_HN: "主否",
  BT_AY: "客是",
  BT_AN: "客否",

  BT_HD_DC: "主 或 和局",
  BT_HA_DC: "主 或 客",
  BT_DA_DC: "客 或 和局",
  BT_HH: "主主",
  BT_HD: "主和",
  BT_HA: "主客",
  BT_DH: "和主",
  BT_DD: "和和",
  BT_DA: "和客",
  BT_AH: "客主",
  BT_AD: "客和",
  BT_AA: "客客",

  BT_H: "主",
  BT_A: "客",
  BT_D: "和局",

  BT_Y: "是",
  BT_N: "否",

  BT_FT1: "全场.1",
  BT_FT2: "全场.2",
  BT_FTX: "全场.X",

  BT_HT1: "半场.1",
  BT_HT2: "半场.2",
  BT_HTX: "半场.X",

  LOT_BS: "大/小",
  LOT_BIG: "大",
  LOT_SMALL: "小",
  LOT_OE: "单/双",
  LOT_ODD: "单",
  LOT_EVEN: "双",
  LOT_OU: "大/小",
  LOT_OVER: "大",
  LOT_UNDER: "小",

  BT_ALL: "@:ui.bet_list",
  
  BT_HDPMMO: "HDPMMO",
  BT_OUMMO: "OUMMO"
};